export default "__VITE_PUBLIC_ASSET__29ee0e27__"